import React from 'react';
import { FadeIn, StaggerContainer, StaggerItem } from './ui/FadeIn';
import { Camera, Star, MessageCircle, WhatsAppIcon } from './Icons';
export function ExperienceSection() {
  return <section className="py-24 bg-linen" data-id="element-84">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-85">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-86">
          <div data-id="element-87">
            <FadeIn data-id="element-88">
              <h2 className="text-3xl md:text-4xl font-serif text-deep-brown mb-8" data-id="element-89">
                Lo que sus invitados van a experimentar
              </h2>

              <div className="prose prose-lg text-brown-medium" data-id="element-90">
                <p className="italic font-serif text-xl text-deep-brown mb-8 border-l-2 border-gold pl-6" data-id="element-91">
                  Imagínese esto: Sus invitados llegan. Ven la mesa. Alguien
                  dice: "Qué linda presentación." Otro toma una foto antes de
                  servirse. Una tercera persona pregunta: "¿De dónde es esto?"
                </p>

                <p className="mb-6" data-id="element-92">
                  Y usted puede responder con total tranquilidad:{' '}
                  <span className="font-medium text-deep-brown" data-id="element-93">
                    "Lo encargué a un catering artesanal de acá."
                  </span>
                </p>

                <p data-id="element-94">
                  Sin estrés previo. Sin carreras de último momento. Sin esa
                  sensación de que algo podría fallar. Solo el placer de haber
                  organizado bien, y el reconocimiento de sus invitados como
                  recompensa.
                </p>
              </div>

              <a href="https://wa.me/59892014876" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-3 bg-[#25D366] hover:bg-[#20bd5a] text-white px-6 py-3 rounded-sm font-medium transition-all duration-300 shadow-sm hover:shadow-md mt-8" data-id="element-95">
                <WhatsAppIcon className="w-5 h-5 text-white" data-id="element-96" />
                Cuéntenos sobre su evento
              </a>
            </FadeIn>
          </div>

          <div data-id="element-97">
            <StaggerContainer className="space-y-6" data-id="element-98">
              <StaggerItem direction="left" data-id="element-99">
                <div className="bg-warm-white p-6 rounded-sm shadow-sm flex items-start gap-6 border border-sand/50" data-id="element-100">
                  <div className="bg-cream p-3 rounded-full text-gold shrink-0" data-id="element-101">
                    <Camera size={24} data-id="element-102" />
                  </div>
                  <div data-id="element-103">
                    <h4 className="font-serif text-lg text-deep-brown mb-1" data-id="element-104">
                      El impacto visual
                    </h4>
                    <p className="text-brown-medium" data-id="element-105">
                      Una presentación que invita a ser fotografiada antes del
                      primer bocado.
                    </p>
                  </div>
                </div>
              </StaggerItem>

              <StaggerItem direction="left" data-id="element-106">
                <div className="bg-warm-white p-6 rounded-sm shadow-sm flex items-start gap-6 border border-sand/50 ml-0 md:ml-8" data-id="element-107">
                  <div className="bg-cream p-3 rounded-full text-terracotta shrink-0" data-id="element-108">
                    <Star size={24} data-id="element-109" />
                  </div>
                  <div data-id="element-110">
                    <h4 className="font-serif text-lg text-deep-brown mb-1" data-id="element-111">
                      La calidad artesanal
                    </h4>
                    <p className="text-brown-medium" data-id="element-112">
                      Sabores auténticos que demuestran el cuidado y la frescura
                      de la elaboración propia.
                    </p>
                  </div>
                </div>
              </StaggerItem>

              <StaggerItem direction="left" data-id="element-113">
                <div className="bg-warm-white p-6 rounded-sm shadow-sm flex items-start gap-6 border border-sand/50 ml-0 md:ml-16" data-id="element-114">
                  <div className="bg-cream p-3 rounded-full text-olive shrink-0" data-id="element-115">
                    <MessageCircle size={24} data-id="element-116" />
                  </div>
                  <div data-id="element-117">
                    <h4 className="font-serif text-lg text-deep-brown mb-1" data-id="element-118">
                      La conversación
                    </h4>
                    <p className="text-brown-medium" data-id="element-119">
                      La comida se convierte en un tema de charla positivo entre
                      sus invitados.
                    </p>
                  </div>
                </div>
              </StaggerItem>
            </StaggerContainer>
          </div>
        </div>
      </div>
    </section>;
}